import { INativeMessage, TNativeMessagePayload } from "src/lib/native-bridge/define-native-message";
import { underlyingFollowNativeMessage, wikifolioWatchlistNativeMessage } from "src/lib/native-bridge/watchlist/watchlist-native-messages";

export const NATIVE_MESSAGES = [underlyingFollowNativeMessage, wikifolioWatchlistNativeMessage] as const;

type TRegisteredNativeMessage = (typeof NATIVE_MESSAGES)[number];

type TNativeMessageMetaOf<Message> = Message extends INativeMessage<infer Type, infer Fields>
    ? { type: Type } & Partial<TNativeMessagePayload<Fields>>
    : never;

export type TNativeMessageMeta = TNativeMessageMetaOf<TRegisteredNativeMessage>;

declare module "@tanstack/react-query" {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- the name is dictated by TanStack Query's type registration
    interface Register {
        mutationMeta: {
            nativeMessage?: TNativeMessageMeta;
        };
    }
}
